import { DateTime } from 'luxon';
import { HTMLProps } from 'react';
import { Rate, useGetFundRates } from '../../../../api/funds-robot/getFundRates';
import { Asset } from '../../../../types/Asset';
import { NavDailyRatesMonth } from './NavDailyRatesMonth';

export const NavDailyRates: React.FC<
    { asset?: Asset; amountOfRows?: number; selectedYear: number } & HTMLProps<HTMLDivElement>
> = ({ amountOfRows = 31, className, selectedYear, asset }) => {
    const fundRateData = useGetFundRates(asset?.id, DateTime.now(), DateTime.now().minus({ year: 10 }));

    let formattedRateData: { monthName: string; data: number[] }[] = [];
    if (!!fundRateData.data) {
        formattedRateData = createNavData(
            fundRateData.data.rates.filter((rate) => DateTime.fromISO(rate.date).year === selectedYear),
            selectedYear,
        );
    } else {
        formattedRateData = createNavData([], selectedYear);
    }

    return (
        <div className={`flex flex-row flex-wrap justify-center ${className}`}>
            {formattedRateData.map((monthData, index) => {
                return (
                    <NavDailyRatesMonth
                        monthData={monthData.data}
                        amountOfRows={amountOfRows}
                        monthName={monthData.monthName}
                        className={`${amountOfRows < 31 ? 'm-2 w-96' : 'm-0.5 w-32 my-4'} text-sm`}
                        key={index}
                    />
                );
            })}
        </div>
    );
};

export const monthNames = [
    { number: 1, name: 'Januari' },
    { number: 2, name: 'Februari' },
    { number: 3, name: 'Maart' },
    { number: 4, name: 'April' },
    { number: 5, name: 'Mei' },
    { number: 6, name: 'Juni' },
    { number: 7, name: 'Juli' },
    { number: 8, name: 'Augustus' },
    { number: 9, name: 'September' },
    { number: 10, name: 'Oktober' },
    { number: 11, name: 'November' },
    { number: 12, name: 'December' },
];
const createNavData = (rates: Rate[], selectedYear: number) => {
    const formattedData = monthNames.map((month) => {
        let temporaryMonthData = rates.filter((rate) => DateTime.fromISO(rate.date).month === month.number);
        //let startDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: 1 });
        let daysInCurrentMonth = DateTime.fromObject({ year: selectedYear, month: month.number }).daysInMonth;
        let endDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: daysInCurrentMonth });
        let monthValues: number[] = [];
        let dateRate: Rate[];

        for (
            let startDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: 1 });
            startDate <= endDate;
            startDate = startDate.plus({ day: 1 })
        ) {
            dateRate = temporaryMonthData.filter((rate) => DateTime.fromISO(rate.date).day === startDate.day);
            if (dateRate.length > 0) {
                monthValues = monthValues.concat(dateRate[0].nav);
            } else {
                monthValues = monthValues.concat(-1);
            }
        }
        return { monthName: month.name, data: monthValues };
    });
    return formattedData;
};
